// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"UN-z","upvoteIcon":"VN-z","downvoteIcon":"WN-z","feedbackIcon":"XN-z"};